<form nz-form [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzSpan]="8" nzRequired>原密码</nz-form-label>
    <nz-form-control [nzSpan]="14" nzValidatingTip="验证中..." [nzErrorTip]="oldPasswordErrorTpl">
      <input 
        type="password" 
        nz-input 
        formControlName="oldPassword" 
        placeholder="请输入原密码" 
      />
      <ng-template #oldPasswordErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          请输入原密码
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="8" nzRequired>新密码</nz-form-label>
    <nz-form-control [nzSpan]="14" nzValidatingTip="验证中..." [nzErrorTip]="newPasswordErrorTpl">
      <input 
        type="password" 
        nz-input 
        formControlName="newPassword" 
        placeholder="请输入新密码（至少6位，包含字母和数字）" 
        (input)="updateConfirmValidator()"
      />
      <ng-template #newPasswordErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          请输入新密码
        </ng-container>
        <ng-container *ngIf="control.hasError('minlength')">
          密码长度至少6位
        </ng-container>
      </ng-template>
      <div nz-extra *ngIf="form.get('newPassword')?.value && !validatePasswordStrength()" style="color: #ff4d4f;">
        密码必须包含字母和数字
      </div>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="8" nzRequired>确认新密码</nz-form-label>
    <nz-form-control [nzSpan]="14" nzValidatingTip="验证中..." [nzErrorTip]="confirmPasswordErrorTpl">
      <input 
        type="password" 
        nz-input 
        formControlName="confirmPassword" 
        placeholder="请再次输入新密码" 
      />
      <ng-template #confirmPasswordErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          请确认新密码
        </ng-container>
        <ng-container *ngIf="control.hasError('confirm')">
          两次输入的密码不一致
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</form>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="cancelClick()" [disabled]="loading">取消</button>
  <button 
    nz-button 
    nzType="primary" 
    (click)="saveClick()" 
    [nzLoading]="loading"
    [disabled]="!form.valid || !validatePasswordStrength()"
  >
    保存
  </button>
</div>